const initState = {
    fetching: false,
    issueTypes:[]
}

const IssueTypeDataReducer = (state = initState, action) => {
    switch (action.type) {
        case 'FETCH_ISSUE_TYPES_DATA':
            return {
                ...state,
                fetching_issueTypes_data: true,
                error: ""
            }

        case 'FETCH_ISSUE_TYPES_DATA_SUCCESSFUL':
            return {
                ...state,
                fetching_issueTypes_data: false,
                issueTypes: action.issueTypes
            }
        
        default:
            return state;
    }

}

export default IssueTypeDataReducer;